import styled from 'styled-components/macro';

const Container = styled.div`
  display: flex;
  position: relative;
  flex-grow: 1;
  flex-direction: column;
`;

const Overlay = styled.div`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 100;
  transition: opacity 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
`;

const LoadingIndicatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
  position: absolute;
  left: calc(50% - 100px);
  top: calc(50% - 20px);
  z-index: 100;
`;

const LoadingLabel = styled.div`
  margin-top: 20px;
`;

export { Container, Overlay, LoadingIndicatorContainer, LoadingLabel };
